import { useQuery } from "@tanstack/react-query";
import { useAccessToken, useTenantData } from "@/hooks";
import { ClassesApi } from "@/openapi/generated";
import { QueryKeys } from "@/lib/types";
import { createAuthenticatedApi } from "@/lib/utils";

export function useClassScheduleGet(opts: {
  classId: number;
  month?: number;
  year?: number;
  enabled?: boolean;
}) {
  const { classId, month, year, enabled = true } = opts;
  const accessToken = useAccessToken();
  const { tenantId } = useTenantData();

  return useQuery({
    queryKey: [QueryKeys.ClassSchedule, classId, month, year],
    enabled: enabled && classId > 0 && !!accessToken,
    refetchOnWindowFocus: false,
    staleTime: 60_000,
    queryFn: async () => {
      if (!accessToken) {
        throw new Error("Authentication token is required");
      }
      const service = createAuthenticatedApi(ClassesApi, accessToken);
      return service.apiClassesIdScheduleGet({
        id: classId,
        month,
        year,
        xTenantID: tenantId,
      });
    },
  });
}
